import { ICondition } from "../../../vendor_core/core/src/states/State";
import BURFeatureModel from "../models/BURFeatureModel";

export class BURFreeSpinsWonCondition implements ICondition {
    public check(): boolean {
        return BURFeatureModel.will_free_spins_trigger;
    }
}
